// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3_Xgx","buttons":"SendReceipts_buttons__3gOBE","email":"SendReceipts_email__2DSsc","bookApptTitle":"SendReceipts_bookApptTitle__2YJbG"};